<template>
  <div>
    <b-form ref="newAllocationForm" id="newAllocationForm">
      <b-table
        fixed
        small
        bordered
        class="bg-white budgetSourcesTable sum-header"
        :items="allocations"
        :fields="allocationsFields"
        head-variant="light"
        show-empty
        :busy="tableIsBusy"
        sticky-header="613px"
      >
        <template #empty>
          <div class="block text-center text-muted p-5">Keine Budgetzuweisungen vorhanden.</div>
        </template>
        <!-- spaltenkopf template war doppelt, habe es erstmal auskommentiert
        <template #head(Amount)="data">
          <div>
            {{ data.label }}
            <span class="font-weight-bold">
              {{ formatCurrency(allocationsTotal) }}
            </span>
          </div>
        </template>
        -->
        <template #head(Ratio)="data">{{ data.label }}</template>
        <!---------------------------------
                    EDIT FIELD  R A T I O
                ---------------------------------->
        <template #cell(Ratio)="data">
          <div
            :class="{
              'action-button': data.item.Source == 'KKE' && ($root.$user.isPlaner || $root.$user.isAdmin),
              'not-allowed': data.item.Source == 'PAT'
            }"
            style="padding-right: 9px"
            v-if="!data.item.editMode"
            @click="toggleRowEdit(data.item, 'ratioField')"
            :title="
              data.item.Source == 'PAT'
                ? 'Budgetzuweisungen der PÄT können nur im Bereich Änderungsmanagement bearbeitet werden'
                : ''
            "
          >
            {{ $utils.numberWithMaxFrictions((data.item.Amount / data.item.Budget) * 100, 1) }} %
          </div>
          <b-input-group append="%" v-show="data.item.editMode">
            <input
              :required="data.item.editMode"
              v-model.lazy="data.item.Ratio"
              class="form-control table-input-field px-2 text-right"
              :ref="'ratioField-' + data.item.Id"
              :name="'ratioField-' + data.item.Id"
              :id="'ratioField-' + data.item.Id"
              @keyup.esc="cancelRowEdit(data.item)"
              @keyup.enter.stop="updateAllocationItem(data.item)"
              placeholder="Anteil"
              type="number"
              min="1"
              step="100"
              @change="onEditRowRatioChanged(data.item)"
              @blur="handleCellLeave"
            />
          </b-input-group>
        </template>
        <template #head(Amount)="data">
          <div style="padding-right: 11px">
            {{ data.label }}
          </div>
          <div class="font-weight-bold text-grey">
            {{ formatCurrency(allocationsTotal) }}
          </div>
        </template>
        <!---------------------------------
            EDIT FIELD A M O U N T
        ---------------------------------->
        <template #cell(Amount)="data">
          <div
            :class="{
              'action-button': data.item.Source == 'KKE' && ($root.$user.isPlaner || $root.$user.isAdmin),
              'not-allowed': data.item.Source == 'PAT'
            }"
            style="padding-right: 9px"
            v-show="!data.item.editMode"
            @click="toggleRowEdit(data.item, 'budgetAmountField')"
            :title="
              data.item.Source == 'PAT'
                ? 'Budgetzuweisungen der PÄT können nur im Bereich Änderungsmanagement bearbeitet werden'
                : ''
            "
          >
            {{ formatCurrency(data.item.Amount) }}
          </div>
          <b-input-group append="€" v-show="data.item.editMode">
            <input
              :required="data.item.editMode"
              v-model.lazy="data.item.Amount"
              class="form-control table-input-field px-2 text-right"
              :ref="'budgetAmountField-' + data.item.Id"
              :name="'budgetAmountField-' + data.item.Id"
              :id="'budgetAmountField-' + data.item.Id"
              @keyup.esc="cancelRowEdit(data.item)"
              @keyup.enter.stop="updateAllocationItem(data.item)"
              placeholder="Betrag"
              type="number"
              min="0.01"
              step="0.01"
              pattern="^\d+(?:\.\d{1,2})?$"
              @change="onEditRowValueChanged(data.item)"
              @blur="handleCellLeave"
            />
          </b-input-group>
        </template>

        <template #custom-foot="">
          <!---------------------------------
                    NEW RECORD ROW
                ---------------------------------->
          <b-tr
            style="border-top: 2px solid #dee2e6; border-bottom: 2px solid #dee2e6"
            v-if="$root.$user.isPlaner || $root.$user.isAdmin"
          >
            <b-td class="p-1 align-middle table-edit-field" style="padding-left: 14px">
              <!--- FIELD   Q U E L L E N T Y P --->
              <!--- <b-form-select
                required
                v-model="selectedSource"
                :options="budgetSources"
                text-field="DisplayText"
                value-field="DbId"
                class="mr-2 border-0 shadow-none table-edit-field"
                id="input-select-2"
                placeholder="Quelle"
                @change="refreshSourceEntries"
              ></b-form-select> --->
              KKE
            </b-td>
            <b-td class="p-0 align-middle table-edit-field" colspan="2">
              <!--- FIELD   Q U E L L E --->
              <b-form-select
                required
                v-model="newBudgetAllocationRecord.DbId"
                :options="sourcesWithBudget"
                text-field="DisplayText"
                value-field="DbId"
                class="mr-2 border-0 shadow-none table-edit-field"
                id="input-select-1"
                placeholder="Kostenkontrolleinheit"
                @change="refreshSelectedAmount"
              ></b-form-select>
            </b-td>
            <b-td class="p-0 align-middle table-edit-field">
              <!--- FIELD P R O Z E N T --->
              <b-input-group append="%">
                <b-input
                  v-model="selectedPercentage"
                  placeholder="Anteil"
                  required
                  type="number"
                  max="100"
                  ref="allocationRatioField"
                  step=".1"
                  class="text-right border-0 shadow-none table-edit-field"
                  @keydown.enter.prevent.stop="createBudgetAllocation"
                  @keyup.esc="selectedPercentage = null"
                  @change="onPercentValueChanged"
                />
              </b-input-group>
            </b-td>
            <b-td class="p-0 align-middle table-edit-field">
              <!--- FIELD B E T R A G --->
              <b-input-group append="€">
                <b-input
                  v-model="selectedAmount"
                  placeholder="Betrag"
                  required
                  type="number"
                  step="0.01"
                  pattern="^\d+(?:\.\d{1,2})?$"
                  ref="allocationAmountField"
                  class="text-right border-0 shadow-none table-edit-field"
                  @keydown.enter.prevent.stop="createBudgetAllocation"
                  @keyup.esc="selectedAmount = null"
                  @change="onAmountValueChanged"
                />
              </b-input-group>
            </b-td>
            <b-td class="py-0 align-middle table-edit-field text-center">
              <!--- A C C E P T   --->
              <b-icon
                icon="check2"
                variant="grey"
                @click="createBudgetAllocation"
                title="Neue Zuordnung speichern"
                class="action-button"
              />
              <b-icon
                icon="x"
                variant="grey"
                @click="clearNewRecordFields"
                title="Neue Zuordnung abbrechen"
                class="action-button"
              />
            </b-td>
          </b-tr>
        </template>
        <template #cell(Anteil)></template>
        <template #cell(actions)="data">
          <!--- E D I T  --->
          <b-icon
            v-show="!data.item.editMode && data.item.Source == 'KKE' && ($root.$user.isPlaner || $root.$user.isAdmin)"
            icon="pencil"
            class="mr-2 action-button"
            variant="grey"
            @click="toggleRowEdit(data.item)"
          ></b-icon>
          <b-icon
            v-if="!data.item.editMode && data.item.Source != 'KKE' && ($root.$user.isPlaner || $root.$user.isAdmin)"
            icon="pencil"
            variant="grey"
            class="mr-2 not-allowed"
            style="color: #ddd"
            title="Zuweisungen aus einer PÄT müssen in der Änderungsverwaltung bearbeitet werden"
          ></b-icon>
          <!--- D E L E T E  --->
          <b-icon
            v-if="!data.item.editMode && data.item.Source == 'KKE' && ($root.$user.isPlaner || $root.$user.isAdmin)"
            icon="trash"
            variant="grey"
            class="action-button mr-2"
            @click="deleteAllocation(data.item)"
          ></b-icon>
          <b-icon
            v-if="!data.item.editMode && data.item.Source != 'KKE' && ($root.$user.isPlaner || $root.$user.isAdmin)"
            icon="trash"
            variant="grey"
            class="not-allowed mr-2"
            style="color: #ddd"
            title="Zuweisungen aus einer PÄT müssen in der Änderungsverwaltung bearbeitet werden"
          ></b-icon>
          <!--- C O M M E N T  --->
          <b-icon
            v-if="!data.item.editMode && ($root.$user.isPlaner || $root.$user.isAdmin)"
            icon="info-circle"
            variant="grey"
            class="action-button"
            @click="editComment(data.item)"
          ></b-icon>
          <!--- A C C E P T   ACTION: ONLY VISIBLE, IF ENTRY IS IN EDIT MODE --->
          <b-icon
            v-show="data.item.editMode"
            title="Bearbeiten"
            icon="check2"
            variant="grey"
            class="action-button mr-2"
            @click="updateAllocationItem(data.item)"
          ></b-icon>
          <!--- C A N C E L   ACTION: ONLY VISIBLE, IF ENTRY IS IN EDIT MODE --->
          <b-icon
            v-show="data.item.editMode"
            title="Bearbeiten abbrechen"
            icon="x"
            variant="grey"
            class="action-button"
            @click="cancelRowEdit(data.item)"
          ></b-icon>
        </template>
      </b-table>
    </b-form>
    <br />
    <EditCommentDialog
      :allocation="currentAllocationUnit"
      :source="currentAllocation"
      :sourceDesc="'Quelle (' + sourceDesc + ')'"
      modalId="EditVECommentModal"
    />
  </div>
</template>

<script>
import AllocationUnitsService from '@/service/AllocationUnitsService';
import CostGroupsService from '@/service/CostGroupsService';
import projectStore from '@/store/Projects';
import settingsStore from '@/store/Settings';
import EditCommentDialog from '@/components/budget/CommentDialog';
import allocationUnitsService from '@/service/AllocationUnitsService';

export default {
  components: { EditCommentDialog },
  data() {
    return {
      sourceDesc: '',
      rowIsDirty: null,
      allocations: [],
      allocationsFields: [
        {
          key: 'Source',
          label: 'Quelle/Ziel',
          thClass: 'align-top',
          thStyle: 'width:100px;',
          tdClass: 'align-middle',
          sortable: true
        },
        {
          key: 'Ordinal',
          label: 'Nr',
          thClass: 'align-top',
          thStyle: 'width:100px;',
          tdClass: 'align-middle',
          sortable: true
        },
        { key: 'DisplayName', label: 'Bezeichnung', thClass: 'align-top', tdClass: 'align-middle', sortable: true },
        {
          key: 'Ratio',
          label: 'Anteil',
          thClass: 'align-top',
          thStyle: 'width:100px;',
          tdClass: 'align-middle text-right p-0',
          sortable: true
        },
        {
          key: 'Amount',
          label: 'Budgetanteil',
          tdClass: 'text-right align-middle p-0',
          thClass: 'align-top text-right noselect',
          thStyle: 'width:250px;padding-right: 5px;',
          formatter: x => this.$utils.numberToCurrency(x, settingsStore.settings['Centbetraege']),
          sortable: true
        },
        {
          key: 'Actions',
          label: 'Aktionen',
          tdClass: 'text-center align-middle',
          thClass: 'align-top',
          thStyle: 'width: 100px'
        }
      ],
      allocationsTotal: 0,
      sourcesWithBudget: [],
      selectedSource: null,
      selectedAmount: null,
      selectedPercentage: null,
      currentAllocation: {
        RefDbId: null
      },
      currentAllocationUnit: {
        Ordinal: null
      },
      newBudgetAllocationRecord: {
        DbId: null,
        Amount: null,
        editMode: false
      },
      tableIsBusy: false,
      budgetSources: [
        {
          DbId: 'costgroups',
          DisplayText: 'KKE'
        },
        {
          DbId: 'pats',
          DisplayText: 'PAT'
        } /*,
        {
          DbId: 've',
          DisplayText: 'VE'
        }*/
      ]
    };
  },

  methods: {
    editComment(item) {
      this.sourceDesc = item.Source;
      this.currentAllocation = { ...item };
      this.$nextTick(() => {
        this.$bvModal.show('EditVECommentModal');
      });
    },
    handleCellLeave(e) {
      if (!e.relatedTarget) this.toggleRowEdit(this.rowIsDirty);
    },
    loadAllocation() {
      allocationUnitsService.getAllocationUnitById(this.$route.params.id).then(record => {
        this.currentAllocationUnit = record;
      });
    },
    loadAllocations() {
      AllocationUnitsService.getAllocationUnitAllocations(this.$route.params.id)
        .then(results => {
          this.allocations = results.map(x => {
            x.Id = x.Source + x.RefDbId;
            x.editMode = false;
            x.Amount = parseFloat(x.Amount);
            x.Ratio = 0;
            return x;
          });
          this.recalcBudgetSum();
        })
        .catch(err => this.$showError(this, err.toString()));
    },
    loadBudgetSourcesWithBudget() {
      this.sourcesWithBudget = [];
      CostGroupsService.getBudgetSourcesWithBudget('costgroups')
        .then(results => {
          if (results.length == 0) {
            this.sourcesWithBudget = [{ value: 'no', DisplayText: 'Keine Einträge vorhanden.', disabled: true }];
          } else {
            for (var x of results) {
              x.DisplayText =
                x.Ordinal +
                ' ' +
                x.DisplayName +
                ' (' +
                this.$utils.numberToCurrency(x.BudgetSaldo, settingsStore.settings['Centbetraege']) +
                ')';
              if (x.DbId != this.$route.params.id && parseFloat(x.BudgetSaldo) > 0) this.sourcesWithBudget.push(x);
            }
          }
        })
        .catch(err => this.$showError(this, err.toString()));
    },
    createBudgetAllocation() {
      // get the selected source record
      const source = this.sourcesWithBudget.find(x => x.DbId == this.newBudgetAllocationRecord.DbId);
      const input = this.$refs.allocationAmountField.$el;

      //      const sourceType = this.budgetSources.find(x => x.DbId == this.selectedSource);
      this.newBudgetAllocationRecord.Amount = parseFloat(this.selectedAmount);

      input.setCustomValidity('');
      // wenn geschoben wird, muss geprüft werden, dass der Amount nicht größer als das aktuelle Budget der VE ist
      if (this.newBudgetAllocationRecord.Amount == 0) {
        input.setCustomValidity('Budget muss größer 0 sein!');
        input.reportValidity();
        return;
      } else if (this.newBudgetAllocationRecord.Amount < 0) {
        if (this.newBudgetAllocationRecord.Amount * -1 > this.allocationsTotal) {
          input.setCustomValidity('Budget darf nicht überschritten werden!');
          input.reportValidity();
          return;
        }
      } else if (source.BudgetSaldo < this.newBudgetAllocationRecord.Amount) {
        input.setCustomValidity('Budget darf nicht überschritten werden!');
        input.reportValidity();
        /*      } else if (sourceType.DbId != 've' && this.newBudgetAllocationRecord.Amount <= 0) {
        input.setCustomValidity('Budget darf nicht kleiner oder gleich 0 sein!');
        input.reportValidity();*/
      } else if (this.allocationsTotal + this.newBudgetAllocationRecord.Amount < 0) {
        input.setCustomValidity('VE Budget darf nicht kleiner 0 sein!');
        input.reportValidity();
      } else {
        // Update list view entry with reduced budget

        source.BudgetSaldo -= this.newBudgetAllocationRecord.Amount;
        source.DisplayText =
          source.Ordinal +
          ' ' +
          source.DisplayName +
          ' (' +
          this.$utils.numberToCurrency(source.BudgetSaldo, settingsStore.settings['Centbetraege']) +
          ')';
        // prepare new record for API Post and allocations array insertion
        this.recordToAdd = {};
        this.recordToAdd.SourceDbId = source.DbId;
        this.recordToAdd.Amount = this.newBudgetAllocationRecord.Amount;
        this.recordToAdd.Ordinal = source.Ordinal;
        this.recordToAdd.Budget = source.Budget;
        this.recordToAdd.Source = 'KKE'; // to show in table only
        this.recordToAdd.DisplayName = source.DisplayName;

        const allocation = {
          DbId: source.DbId,
          VeId: this.$route.params.id,
          Amount: this.recordToAdd.Amount,
          sourceType: 'costgroups' //sourceType.DbId
        };

        this.tableIsBusy = true;
        AllocationUnitsService.createAllocation(allocation)
          .then(result => {
            this.recordToAdd.RefDbId = result.insertId;
            this.recordToAdd.Id = 'KKE' + result.insertId;
            this.recordToAdd.editMode = false;
            this.allocations.push(this.recordToAdd);
            this.$showSuccess(this, 'Budget zuordnen', 'Budget erfolgreich zugeordnet.');
            this.loadBudgetSourcesWithBudget();
          })
          .catch(err => {
            if (err.response) this.$showError(this, err.response.data.error.text);
            else this.$showError(this, err.toString());
          })
          .finally(() => {
            this.recalcBudgetSum();
            this.clearNewRecordFields();
            this.tableIsBusy = false;
          });
      }
    },
    clearNewRecordFields() {
      this.newBudgetAllocationRecord = {};
      this.selectedSourceObject = null;
      this.selectedPercentage = null;
      this.selectedAmount = null;
      this.selectedSource = null;
    },
    refreshSourceEntries() {
      this.loadBudgetSourcesWithBudget();
    },
    refreshSelectedAmount() {
      const source = this.sourcesWithBudget.find(x => x.DbId == this.newBudgetAllocationRecord.DbId);
      this.selectedSourceObject = source;
      this.selectedAmount = parseFloat(source.BudgetSaldo);
      this.newBudgetAllocationRecord.Amount = source.BudgetSaldo;
      this.selectedPercentage = 100;
    },
    deleteAllocation(item) {
      this.$bvModal
        .msgBoxConfirm('Soll die Budgetzuordnung wirklich gelöscht werden?', {
          title: 'Zuordnung löschen',
          okTitle: 'Bestätigen',
          cancelTitle: 'Abbrechen',
          okVariant: 'danger',

          centered: true
        })
        .then(confirmed => {
          if (confirmed) {
            if (this.allocationsTotal - item.Amount < 0) {
              return this.$showError(
                this,
                'Das Löschen des Eintrags würde zu einem negativen Budget der Vergabeeinheit führen.'
              );
            }
            AllocationUnitsService.deleteAllocation(item)
              .then(() => {
                this.$utils.deleteItemFromArray(this.allocations, x => x.RefDbId == item.RefDbId);

                this.refreshSourceEntries();
                this.recalcBudgetSum();
                this.$showSuccess(this, 'Zuordnung löschen', 'Zuordnung erfolgreich gelöscht');
                if (this.allocations.length == 0) this.checkedAllCostGroups = false;
              })
              .catch(err => {
                if (err.response) this.$showError(this, err.response.data);
                else this.$showError(this, err.toString());
              });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    toggleRowEdit(item, fieldToFocus = null) {
      if (item && item.Source != 'KKE') return; // editing shall only be possible, when source is KKE
      // if clicking on another row, remove editMode from all rows that eventually were in editMore before
      /*

      */
      if (!(this.$root.$user.isPlaner || this.$root.$user.isAdmin)) return;
      if (item && item.editMode && this.rowIsDirty) {
        return this.updateAllocationItem(this.rowIsDirty);
      }
      if (!item) {
        for (const allocation of this.allocations.filter(x => x.editMode)) {
          allocation.editMode = false;
        }
        // item is empty, if editing was cancled without any changes (rowIsDirty == null)
        return;
      }
      console.log('zzz a', item.editMode);
      if (item.editMode == false) {
        console.log('zzz into');
        // we are going to toggle to editMode
        CostGroupsService.getBudgetSourceById(item.SourceDbId, item.Source)
          .then(source => {
            console.log('zzz cd');
            item.editMode = true;
            let budget_available = 0;
            if (item.Source == 'VE') {
              budget_available = source.Budget;
            } else {
              budget_available =
                parseFloat(item.Amount) + parseFloat(source.Budget) - parseFloat(source.BudgetAllocated);
            }

            item.BudgetAvailable = budget_available; // we store the source temporarily, so we can calculate precentage

            item.Ratio = parseFloat((item.Amount / budget_available) * 100).toFixed(1); // calculate ratio between current amount and available budget
            this.rowDataBackup = { ...item };

            this.$nextTick(() => {
              if (fieldToFocus) {
                this.$refs[fieldToFocus + '-' + item.Id].focus();
              } else this.$refs['budgetAmountField-' + item.Id].focus();
            });
          })
          .catch(err => this.$showError(this, 'Zuordnung bearbeiten', err.toString()));
      } else {
        item.editMode = false;
        delete item.BudgetAvailable;
      }
    },
    cancelRowEdit(item) {
      item.editMode = false;
      // user has canceled editing, so revert value fields to the state, they had before editMode.
      item.Ordinal = this.rowDataBackup.Ordinal;
      item.DisplayName = this.rowDataBackup.DisplayName;
      item.Amount = this.rowDataBackup.Amount;
      item.Ratio = this.rowDataBackup.Ratio;
      this.rowDataBackup = null;
    },
    recalcBudgetSum() {
      this.allocationsTotal = 0;
      this.allocations.map(x => {
        this.allocationsTotal += parseFloat(x.Amount);
      });
      this.$eventBus.$emit('budget:changed', this.allocationsTotal);
      return;
    },
    formatCurrency(number) {
      return this.$utils.numberToCurrency(number, settingsStore.settings['Centbetraege']);
    },
    updateAllocationItem(item) {
      const input = this.$refs['budgetAmountField-' + item.Id];

      input.setCustomValidity(''); // remove current displayed notification

      if (item.Source == 'KKE' && parseFloat(item.Amount) <= 0) {
        input.setCustomValidity('Budget darf nicht kleiner oder gleich 0 sein!');
        return input.reportValidity();
      } else if (item.Source == 'KKE' && parseFloat(item.Amount) > item.BudgetAvailable) {
        input.setCustomValidity('Budget darf nicht überschritten werden!');
        return input.reportValidity();
      } else if (
        // Postive PAT
        item.Source == 'PAT' &&
        parseFloat(item.Budget) > 0 &&
        (parseFloat(item.Amount) > item.BudgetAvailable || parseFloat(item.Amount) <= 0)
      ) {
        input.setCustomValidity('Budget darf nicht überschritten werden!');
        return input.reportValidity();
      } else if (
        item.Source == 'PAT' &&
        parseFloat(item.Budget) < 0 &&
        (parseFloat(item.Amount) < item.BudgetAvailable || parseFloat(item.Amount) >= 0)
      ) {
        input.setCustomValidity('Budget darf nicht unterschritten werden!');
        return input.reportValidity();
      }

      item.editMode = false;
      item.Amount = parseFloat(item.Amount);
      return AllocationUnitsService.updateAllocation(item)
        .then(() => {
          this.$showSuccess(this, 'Budgetierung bearbeiten', 'Budgetierung erfolgreich aktualisiert.');
          this.rowIsDirty = null;
          this.recalcBudgetSum();
          this.refreshSourceEntries();
        })
        .catch(err => {
          this.loadAllocations();
          if (err.response) this.$showError(this, err.response.data.error);
          else this.$showError(this, err.toString());
        });
    },
    takeOverBudget() {
      if (!this.newBudgetAllocationRecord.Amount || this.newBudgetAllocationRecord.Amount == '') {
        this.newBudgetAllocationRecord.Amount = this.selectedAmount;
      }
    },
    onPercentValueChanged() {
      this.selectedAmount = parseFloat(this.selectedSourceObject.BudgetSaldo * (this.selectedPercentage / 100)).toFixed(
        2
      );
    },
    onAmountValueChanged() {
      if (!this.selectedAmount) return;
      this.selectedPercentage = parseFloat((this.selectedAmount / this.selectedSourceObject.BudgetSaldo) * 100).toFixed(
        1
      );
    },
    onEditRowRatioChanged(item) {
      this.rowIsDirty = item;
      item.Amount = (item.BudgetAvailable * item.Ratio) / 100;
    },
    onEditRowValueChanged(item) {
      this.rowIsDirty = item;
      item.Ratio = parseFloat((item.Amount / item.BudgetAvailable) * 100).toFixed(1);
    }
  },
  activated() {
    this.loadAllocation();
    this.loadAllocations();
    this.loadBudgetSourcesWithBudget();
    this.clearNewRecordFields();
  },
  computed: {
    lookupUrl() {
      return `/api/projects/${projectStore.activeProject.DbId}/costgroups/budgets`;
    }
  }
};
</script>

<style scoped></style>
